import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  Typography,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  TextField as MuiTextField,
  Card,
} from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useMemo, useState } from "react";
import { operatorsGet, operatorEdit, operatorDelete } from "../../api/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import AddIcon from "@mui/icons-material/Add";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { FastField, Form, Formik } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-mui";
import React from "react";
import moment from "moment";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export const APIOperators = ({
  selectedBusiness,
}: {
  selectedBusiness: any;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [operatorDialogOpen, setOperatorDialogOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [selected, setSelected] = useState<any | null>(null);
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [secretKey, setSecretKey] = useState("");

  const dateFormat = "YYYY-MM-DD HH:mm";

  const queryClient = useQueryClient();

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfOrganizationsResponse } = useQuery(
    'getUserAdminOfOrganizations',
    getUserAdminOfOrganizations,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfOrganizations = getUserAdminOfOrganizationsResponse!.data;

  const [selectedBusinessId, setselectedBusinessId] = useState<number>(
    userAdminOfOrganizations[0]?.id,
  );
  */

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery(
    ["apiOperators", selectedBusiness?.id],
    operatorsGet(selectedBusiness?.id),
    {
      enabled: !!selectedBusiness,
      refetchOnWindowFocus: false,
    }
  );
  const data: any = response?.data;

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation("operatorEdit", operatorEdit, {
    onError: (err: any) => {
      alert("Error", err.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries("apiOperators");
    },
    onSuccess: (response: any) => {
      setRightDrawerOpen(false);
      if (!selected) {
        setName(response.data.name);
        setId(response.data.id);
        setSecretKey(response.data.secretKey);
        setOperatorDialogOpen(true);
      }
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: "name",
        headerName: "Name",
        sortable: true,
        initialSort: "asc",
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 2,
        minWidth: 210,
        filter: true,
      },
      {
        field: "id",
        headerName: "ID",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 2,
        minWidth: 210,
        filter: true,
      },
      {
        field: "createdAt",
        headerName: "Created at",
        sortable: true,
        flex: 0.5,
        minWidth: 162,
        valueFormatter: ({ data }) => {
          return moment(data.createdAt).format(dateFormat);
        },
      },
      {
        field: "updatedAt",
        headerName: "Updated at",
        sortable: true,
        flex: 0.5,
        minWidth: 162,
        valueFormatter: ({ data }) => {
          return moment(data.updatedAt).format(dateFormat);
        },
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  if (isLoading) {
    return (
      <Box sx={{ textAlign: "center", mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: "100vw", sm: "600px" } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: "1.3em", fontWeight: 500, m: "16px 24px" }}
            >
              {!!selected ? "Edit API operator" : "Add API operator"}
            </Typography>
            <Divider />
            <Box sx={{ padding: "24px" }}>
              <Box sx={{ mb: "20px" }}>
                <Typography sx={{ fontWeight: 500, display: "inline" }}>
                  Business:{" "}
                </Typography>
                {selectedBusiness?.name}
              </Box>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {/*
              {!selected &&
                'Enter the email address of the registered user you want give permissions to the organization.'}
              */}
              <Formik
                validateOnMount
                initialValues={{
                  id: selected?.id || undefined,
                  name: selected?.name || "",
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required("Required"),
                })}
                onSubmit={async (values: any, { setSubmitting }) => {
                  values.businessId = selectedBusiness.id;
                  try {
                    await mutateAsync({ values });
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                  refetch();
                  setSubmitting(false);
                  //setRightDrawerOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                }) => (
                  <Form style={{ width: "100%" }}>
                    <Box
                      sx={{
                        width: "100%",
                        marginInline: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        position: "relative",
                      }}
                    >
                      <FastField
                        component={TextField}
                        label="Name"
                        name="name"
                        helperText="The name is just for you to identify the operator."
                        size="small"
                      />
                      {!!selected && (
                        <>
                          <FastField
                            component={TextField}
                            label="Operator ID"
                            name="id"
                            size="small"
                            InputProps={{
                              readOnly: true,
                            }}
                          />

                          <FastField
                            component={TextField}
                            label="Secret key"
                            name="secretKey"
                            value="•••••••••••••••••••••••••••••••••"
                            size="small"
                            helperText="Secret key is not recoverable. If you lose it, you will need to create a new operator."
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </>
                      )}
                      <Box
                        sx={{
                          textAlign: "right",
                          margin: "16px 0",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => setRightDrawerOpen(false)}
                          sx={{ padding: "6px 8px" }}
                        >
                          Back
                        </Button>

                        <Box sx={{ flex: "1 1 auto" }} />
                        {!!selected && (
                          <Button
                            color="primary"
                            disabled={isSubmitting}
                            onClick={() => setDialogOpen(true)}
                            sx={{ padding: "6px 8px" }}
                          >
                            Delete
                          </Button>
                        )}
                        <Box sx={{ flex: "1 1 auto" }} />
                        {/*
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting || !isValid}
                          sx={{ padding: '6px 24px' }}
                          onClick={submitForm}
                        >
                          Create new secret key
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        */}
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting || !isValid}
                          sx={{ padding: "6px 24px" }}
                          onClick={submitForm}
                        >
                          Save
                        </Button>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
              <Typography paragraph>
                Since API keys can be used to perform any API request, including
                those which move money and access sensitive information, you
                must take care to keep your keys secret. Your secret key should
                not be shared, used from client-side code, or stored anywhere
                but your own servers.
              </Typography>
              <Typography paragraph>
                When you create a new secret key, you will only see the full key
                once. Make sure you copy it without missing any characters,
                since it will be masked afterwards for security reasons.
                Spidipay doesn&apos;t know your secret key, so if you lose it,
                you will have to create a new one.
              </Typography>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      {/*       
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The API operator will not be deleted if it has a pending session.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await operatorDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
 */}
      <Dialog
        open={operatorDialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              API operator
            </Typography>
            <MuiTextField
              label="Name"
              defaultValue={name}
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ width: "100%" }}
            />

            <MuiTextField
              label="ID"
              defaultValue={id}
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ width: "100%" }}
            />

            <MuiTextField
              label="Secret key"
              defaultValue={secretKey}
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ width: "100%" }}
            />

            <Typography>
              You will only see the secret key this one time. Make sure you copy
              it without missing any characters, since it will be masked
              afterwards for security reasons.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOperatorDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deletion confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The API operator will not be deleted if it has a pending session.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await operatorDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 0,
            alignItems: "center",
            gap: 1,
            height: "56px",
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: "1.25rem",
            }}
          >
            API Operators
          </Typography>
          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              if (selectedBusiness) {
                setRightDrawerOpen(true);
              } else {
                alert("Info", "Create and select a business first");
              }
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
        </Box>
        <Card
          className="ag-theme-material"
          sx={{
            borderRadius: 0,
            margin: "0 -16px -16px",
            display: "flex",
            overflow: "hidden",
            flexGrow: 1,
            height: "100%",
            boxShadow: "none !important",
          }}
        >
          {isFetching && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Box sx={{ display: isFetching ? "none !important" : "block" }}>
            <AgGridReact
              rowData={rowData}
              className="ag-pointer-row"
              pagination={true}
              floatingFiltersHeight={50}
              paginationAutoPageSize={true}
              columnDefs={columnDefs}
              onRowClicked={({ data }) => {
                setSelected(data);
                setRightDrawerOpen(true);
              }}
            ></AgGridReact>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default APIOperators;
